const ACQUISITION_SOURCES = [
    { value: "leadforge", label: "LeadForge" },
    { value: "personal_network", label: "Personal Network" },
    { value: "referral", label: "Referral" },
    { value: "inbound_website", label: "Inbound Website" },
    { value: "networking", label: "Networking" },
    { value: "tiktok", label: "TikTok" },
    { value: "instagram", label: "Instagram" },
    { value: "linkedin", label: "LinkedIn" },
    { value: "reddit", label: "Reddit" },
    { value: "google_ads", label: "Google Ads" },
    { value: "paid_lead", label: "Paid Lead" },
    { value: "other", label: "Other" },
];

const PRIMARY_OFFERS = [
    { value: "website", label: "Website" },
    { value: "marketing", label: "Marketing" },
    { value: "striver", label: "Striver" },
    { value: "custom_software", label: "Custom Software" },
    { value: "multi_service", label: "Multi-Service" },
    { value: "unknown", label: "Unknown" },
];

function getOptionLabel(options, value) {
    const normalized = String(value || "unknown").toLowerCase();
    return options.find((option) => option.value === normalized)?.label || "Unknown";
}

export function getAcquisitionSourceLabel(value) {
    return getOptionLabel([...ACQUISITION_SOURCES, { value: "unknown", label: "Unknown" }], value);
}

export function getPrimaryOfferLabel(value) {
    return getOptionLabel(PRIMARY_OFFERS, value);
}

export { ACQUISITION_SOURCES, PRIMARY_OFFERS };